import { Card, CardContent, Typography, Avatar, Box } from "@mui/material";

export default function KPICard({
  titulo,
  valor,
  unidade = "",
  subtitulo,
  icon,
  corIcone = "#0d6efd",
  onClick,
}) {
  return (
    <Card
      onClick={onClick}
      sx={{
        height: 120, // 🔒 altura fixa (padronização total)
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.2s ease",
        "&:hover": onClick
          ? { boxShadow: 6, transform: "translateY(-2px)" }
          : {},
      }}
    >
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: "16px !important", // 🔧 evita variação de altura
        }}
      >
        {/* TEXTO */}
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" color="text.secondary">
            {titulo}
          </Typography>

          <Typography variant="h5" fontWeight={700} noWrap>
            {valor}
            {unidade}
          </Typography>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ minHeight: 18 }} // 🔒 reserva espaço mesmo sem subtítulo
          >
            {subtitulo || ""}
          </Typography>
        </Box>

        {/* ÍCONE */}
        <Avatar
          sx={{
            bgcolor: corIcone,
            width: 44,
            height: 44,
            ml: 2, // 🔥 espaçamento correto do texto
            flexShrink: 0,
          }}
        >
          {icon}
        </Avatar>
      </CardContent>
    </Card>
  );
}
